import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ElementRef, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { MyDatePickerModule } from 'mydatepicker';
import { GuestAppointmentComponent, GuestAppointmentService } from './index';
import { MentisSoftSharedModule } from "../appindex";
import { IonRangeSliderModule } from "ng2-ion-range-slider";
import { NgxLoadingModule } from 'ngx-loading';
import { GuestAppointmentRoutingModule } from './GuestAppointment.routing';
@NgModule({
    imports: [CommonModule, FormsModule, MentisSoftSharedModule, MyDatePickerModule, IonRangeSliderModule, NgxLoadingModule, GuestAppointmentRoutingModule],  ///For Loading Ondemand or Onclick of Button (Book Appointments)
    declarations: [GuestAppointmentComponent],
    exports: [GuestAppointmentComponent],
    providers: [GuestAppointmentService]
})
export class GuestAppointmentModule { }


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/GuestAppointment/GuestAppointment.module.ts